export default __webpack_public_path__ + "static/media/a.1004f818.jpg";